import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Box } from '@theme-ui/components';
import styled from '@emotion/styled';

import ErrorBoundary from '@app/components/ErrorBoundary';
import Link from '@app/components/Link';
import PageTitle from '@app/components/PageTitle';
import theme from '@app/styles/theme';

import AuthCheck from '../../components/AuthCheck';
import {
  Skeleton,
  SubHeader,
  SubHeaderMenu,
  SubHeaderTitle,
} from '../../components/Skeleton/Skeleton';
import messages from './AccountLayout.messages';

const Wrapper = styled.div`
  max-width: ${theme.layout.containerMaxWidth};
  margin: 0 auto;
  justify-content: space-between;

  & ol,
  & ul {
    line-height: 1.5;
  }
`;

const AccountLayout = ({
  children,
  noBackgroundColor = false,
}: {
  children?: React.ReactNode;
  noBackgroundColor?: boolean;
}) => {
  const { language } = useParams<{ language: string }>();

  return (
    <AuthCheck>
      <Skeleton>
        <ErrorBoundary>
          <PageTitle>{messages.title}</PageTitle>

          <SubHeader>
            <SubHeaderTitle>
              <a href={`/${language}/account/`}>
                <FormattedMessage {...messages.title} />
              </a>
            </SubHeaderTitle>

            <SubHeaderMenu>
              <a href={`/${language}/my-account/account-settings/`}>
                <FormattedMessage {...messages.accountSettings} />
              </a>
              <Link to="/:language/account/orders/">
                <FormattedMessage {...messages.orderHistory} />
              </Link>
              <a
                href={`/${language}/my-account/my-products-serials-downloads/`}
              >
                <FormattedMessage {...messages.productsSerialsAndDownloads} />
              </a>
              <a href={`/${language}/support/downloads/`}>
                <FormattedMessage {...messages.updatesAndDrivers} />
              </a>
              <Link to="/:language/account/subscription/">
                <FormattedMessage {...messages.subscription} />
              </Link>
              <a href={`/${language}/my-account/license-transfer/`}>
                <FormattedMessage {...messages.licenseTransfer} />
              </a>
            </SubHeaderMenu>
          </SubHeader>

          <Box
            p={[20, 40]}
            bg={noBackgroundColor ? 'none' : 'white'}
            sx={{ flexGrow: 1 }}
          >
            <Wrapper>{children}</Wrapper>
          </Box>
        </ErrorBoundary>
      </Skeleton>
    </AuthCheck>
  );
};

export default AccountLayout;
